import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Button } from '../../../../components/Button';
import { Section } from '../../../../components/Section';
import { Text } from '../../../../components/Text';
import { Spacing } from '../../../../theme/Spacing';
import { SettingsPasswordChangeModal } from './SettingsPasswordChangeModal';

const StyledButton = styled(Button)`
  height: 2.3rem;
  margin-top: ${Spacing.s};
  width: fit-content;

  &:hover {
    background-color: ${({ theme }) => theme.mainHover};
  }
`;

export const SettingsPasswordChange: React.FC = () => {
  const [changePasswordModalVisible, setNewEmailPasswordModalVisible] =
    useState(false);

  const { t } = useTranslation(undefined, {
    keyPrefix: 'settings.general.changePassword',
  });

  return (
    <Section title={t('title')}>
      <Text color="fgSecondary">{t('description')}</Text>

      <StyledButton
        onClick={() => setNewEmailPasswordModalVisible(true)}
        width="12rem"
      >
        {t('start.button')}
      </StyledButton>

      <SettingsPasswordChangeModal
        open={changePasswordModalVisible}
        onClose={() => setNewEmailPasswordModalVisible(false)}
      />
    </Section>
  );
};
